/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    BROADCAST_FORM_SPLIT_HOOK_STATE
 * Date:         2025-12-30
 * Modified By:  Cursor
 *
 * Description:
 * Extracted state management from BroadcastForm.tsx.
 */

import { useState, useEffect, useRef } from "react";
import { Currency } from "../../../../interfaces/Currency";
import { checkAuthStatus } from "../../../../utils/authUtils";

export const useBroadcastState = () => {
  const [userCurrency, setUserCurrency] = useState<Currency>("USD");
  const [currencyLoaded, setCurrencyLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pendingJobId, setPendingJobId] = useState<string | null>(null);
  const [pendingRowId, setPendingRowId] = useState<string | null>(null);
  const [chooserOpen, setChooserOpen] = useState(false);
  const [chooserItems, setChooserItems] = useState<any[]>([]);
  const [chooserAddOthers, setChooserAddOthers] = useState(false);
  const appliedJobIdsRef = useRef<Set<string>>(new Set());

  // [2026-02-13] cookie-auth fix: Use checkAuthStatus() instead of deprecated getUserInfoFromToken()
  useEffect(() => {
    checkAuthStatus().then((userInfo) => {
      if (userInfo?.preferredCurrency) {
        setUserCurrency(userInfo.preferredCurrency as Currency);
      }
    }).finally(() => setCurrencyLoaded(true));
  }, []);

  return {
    userCurrency,
    currencyLoaded,
    isSubmitting,
    setIsSubmitting,
    pendingJobId,
    setPendingJobId,
    pendingRowId,
    setPendingRowId,
    chooserOpen,
    setChooserOpen,
    chooserItems,
    setChooserItems,
    chooserAddOthers,
    setChooserAddOthers,
    appliedJobIdsRef,
  };
};
